module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-01@2x.762f6963.jpg";